var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:20px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "E407, setting, Media, media player, multimedia",
    id: "E407_setting_Media_media_player_multimedia"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M502,291.14V220.86H469a214.81,214.81,0,0,0-37.54-90.63L454.8,106.9,405.1,57.2,381.77,80.53A214.81,214.81,0,0,0,291.14,43V10H220.86V43a214.81,214.81,0,0,0-90.63,37.54L106.9,57.2,57.2,106.9l23.33,23.33A214.81,214.81,0,0,0,43,220.86H10v70.28H43a214.81,214.81,0,0,0,37.54,90.63L57.2,405.1l49.7,49.7,23.33-23.33A214.81,214.81,0,0,0,220.86,469v33h70.28V469a214.81,214.81,0,0,0,90.63-37.54L405.1,454.8l49.7-49.7-23.33-23.33A214.81,214.81,0,0,0,469,291.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256,
    cy: 256,
    r: 141.79
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.a13fa54cbd645ab1ef1cd243ac99f32b.svg";
export { ForwardRef as ReactComponent };